export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -01.9e1aff62.png";